module.exports = __webpack_public_path__ + "img/New PACI Flow - New-9.44145d78.png";